var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOldestPasswordCs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "smd7tq4eva",
    d: "M0 0h19.167v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2sa83199sb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#smd7tq4eva"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.703 11.11a2.13 2.13 0 0 0-1.856-2.113 2.122 2.122 0 0 0-2.325 1.58 2.13 2.13 0 0 0 1.275 2.508v2.155a.78.78 0 1 0 1.558 0v-2.155a2.125 2.125 0 0 0 1.348-1.975zm7.444-3.76-1.622 10.915A2.052 2.052 0 0 1 15.508 20H3.665a2.047 2.047 0 0 1-2.017-1.735L.025 7.35C-.206 5.854 1.195 4.788 2.602 5h12.98c.324.003 1.214-.002 1.533 0a2.073 2.073 0 0 1 2.032 2.35zM16.581 4H2.601V2.045A2.049 2.049 0 0 1 4.638 0h.92a2.038 2.038 0 0 1 2.036 2h6.95a2.043 2.043 0 0 1 2.037 2z",
    fill: "#AEB3B7",
    mask: "url(#2sa83199sb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldestPasswordCs);
export default __webpack_public_path__ + "static/media/oldest-password-cs.67c70fd7378041f3ca9382702c5d48d1.svg";
export { ForwardRef as ReactComponent };